import { connect } from "react-redux";

import Benutzer from "./Benutzer";

export default connect(state => ({
	user: state.settings.user,
	auth: state.user
}))(Benutzer);
